/** @format */

import React, { Component } from 'react';
import { Form, Menu, Dropdown } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { getUnixDateFromTimestamp } from '../../../helpers/getUnixDateFromTimestamp';
import { getTimestamp } from '../../../helpers/getTimestamp';

@inject('RequestsStore', 'CarPartsStore')
@observer
class AdvanceReqSearch extends Component {
  renderProgressItems = () => {
    let { RequestsStore } = this.props;
    let status = RequestsStore.requestsParams.filter.status;
    let list;
    let activeProgress = [
      'tutti i progressi',
      'auto gestione',
      'inoltrata al magazzino',
      'controllo magazzino',
      'controllo terminato',
      'contrattazione vendita',
    ];
    let archivedProgress = [
      'tutti i progressi',
      'completata con vendita',
      'completata senza vendita',
    ];
    list = status === 'attiva' ? activeProgress : archivedProgress;
    let renderedList = list.map((item, index) => {
      return (
        <Dropdown.Item
          key={index}
          onClick={(e, result) => RequestsStore.progressSearchInput(result)}
        >
          {item}
        </Dropdown.Item>
      );
    });
    return renderedList;
  };

  render() {
    let { RequestsStore, CarPartsStore } = this.props;
    let deepSearch = RequestsStore.requestsParams.deepSearch.active;
    let start = RequestsStore.requestsParams.timeInterval.start;
    let end = RequestsStore.requestsParams.timeInterval.end;

    return (
      <div
        className={
          deepSearch ? 'advance-search-wrapper open' : 'advance-search-wrapper'
        }
      >
        <Form>
          <Menu className="advance-toolbar" borderless size="small">
            <Menu.Menu position="left">
              <Menu.Item>
                <Dropdown
                  text={RequestsStore.requestsParams.progressSearch.value}
                >
                  <Dropdown.Menu>{this.renderProgressItems()}</Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item>
                <Dropdown
                  selection
                  placeholder="Ricambio"
                  clearable
                  search
                  options={Object.values(CarPartsStore.items)
                    .map(({ data, uid }) => ({
                      key: uid,
                      value: uid,
                      text: data.name,
                    }))
                    .sort((a, b) => a.text.localeCompare(b.text))}
                  value={RequestsStore.requestsParams.filterByPartId}
                  onChange={(_, data) => {
                    if (data.value === '') {
                      return RequestsStore.clearFilterByPartId();
                    }

                    RequestsStore.setFilterByPartId(data.value);
                  }}
                />
              </Menu.Item>
            </Menu.Menu>
            <Menu.Menu position="right">
              <Menu.Item>
                <Form.Input
                  inline
                  size="mini"
                  name="end"
                  max={getUnixDateFromTimestamp(start)}
                  value={getUnixDateFromTimestamp(end)}
                  onChange={e => {
                    let date = e.target.value + ' 00:00:00';
                    RequestsStore.timeIntervalInput(date, e.target.name);
                  }}
                  label="Dal"
                  type="date"
                ></Form.Input>
              </Menu.Item>
              <Menu.Item>
                <Form.Input
                  inline
                  size="mini"
                  name="start"
                  onChange={e => {
                    let date = e.target.value + ' 23:59:59';
                    RequestsStore.timeIntervalInput(date, e.target.name);
                  }}
                  min={getUnixDateFromTimestamp(end)}
                  max={getUnixDateFromTimestamp(getTimestamp())}
                  value={getUnixDateFromTimestamp(start)}
                  label="Al"
                  type="date"
                ></Form.Input>
              </Menu.Item>
              {/* <Menu.Item>
                                <Form.Button
                                    size="mini"
                                    color="green"
                                    type="submit"
                                    ><Icon name="search"/>Cerca
                                </Form.Button>
                            </Menu.Item> */}
            </Menu.Menu>
          </Menu>
        </Form>
      </div>
    );
  }
}

export default AdvanceReqSearch;
